// get values data from query
import request, { gql } from "graphql-request";


export const allLeadprospect = gql`
   query {
    allLeadprospect {
      id
      prsid
      companyName
      mailId
      contactNumber
      leadSource
      addressLine1
      nextFollowUpdate
      createdAt
      user {
        username
      }
    }
  }
`;



export const getLeadprospectDetailByUser = gql`
  query getLeadprospectDetailByUser($id: String!) {
    getLeadprospectDetailByUser(id: $id) {
      id
      firstName
      lastName
      companyName
      mailId
      contactNumber
      secondaryNumber
      jobTitle
      websiteUrl
      type
      addressLine1
      addressLine2
      country
      state
      city
      zipCode
      leadSource
      stage
      companySize
      lastContactDate
      nextFollowUpdate
      indutry
      user {
        username
      }
    }
  }
`; 
export const getLeadprospectDetail = gql`
  query GetLeadProspectDetail($id: String!) {
    getLeadprospectDetail(id: $id) {
      id
      firstName
      lastName
      companyName
      mailId
      contactNumber
      secondaryNumber
      jobTitle
      websiteUrl
      type
      addressLine1
      addressLine2
      country
      state
      city
      zipCode
      leadSource
      stage
      status
      companySize
      lastContactDate
      nextFollowUpdate
      indutry
    }
  }
`; //getvalule by id using update value query

// export const AllCustomerDetailsQuery = gql`
//   query getCustomerdetailByUser($id: String!) {
//     getCustomerdetailByUser(id: $id) {
//       id
//       legalName
//       customerCategory
//       pan
//     }
//   }
// `

export const AllCustomerDetailsQuery = gql`
query {
    allCustomer {
      id
      cusid
      legalName
      customerCategory
      pan
      address1Line1
      address2Line1
      createdAt
      user {
        username
      }
    }
  }
`;
export const AllCustomerDataByUserQuery = gql`
query getCustomerdetailByUser($id: String!) {
    getCustomerdetailByUser(id: $id) {
      id
    cusid
      legalName
      customerCategory
      address1Line1
      address2Line1
      pan
      user {
        username
      }
    createdAt
    }
  }
`;
export const AllCustomerDataByMasterQuery = gql`
query getCustomerdetailByMaster($id: String!) {
    getCustomerdetailByMaster(id: $id) {
      id
    cusid
      legalName
      customerCategory
      address1Line1
      address2Line1
      pan
      createdAt
      user {
        username
      }
    }
  }
`;

// export const AllVendorDetailsQuery = gql`
//  query getVendordetailByUser($id:String!) {
//   getVendordetailByUser(id:$id){
//     id
//     legalName
//     vendorCategory
//     pan
//   }
// }
// `;

export const AllVendorDetailsQuery = gql`
  query {
    allVendor {
      id
      legalName
      vendorCategory
      pan
      user {
        username
      }
    }
  }
`;
export const AllVendorDetailByUserQuery = gql`
  query getVendordetailByUser($id: String!) {
    getVendordetailByUser(id: $id) {
      id
      legalName
      vendorCategory
      pan
      user {
        username
      }
    }
  }
`;

export const AllVendorDetailByMasterQuery = gql`
  query getVendordetailByMaster($id: String!) {
    getVendordetailByMaster(id: $id) {
      id
      legalName
      vendorCategory
      pan
      user {
        username
      }
    }
  }
`;

export const AllRoleDetailsQuery = gql`
  query {
    allRoleDetail {
      id
      role
      user {
        username
      }
    }
  }
`;

export const AllEmployeeDetailsQuery = gql`
  query getUserDetailByMaster($id: String!) {
    getUserDetailByMaster(id: $id) {
      id
      username
      email
      role
      contactno
      lastUpdate
    }
  }
`;

export const getContactdetailByUser = gql`
  query getContactdetailByUser($id: String!) {
    getContactdetailByUser(id: $id) {
      id
      firstName
      lastName
      organizationId
      organizationName
      contactNumber
      organizationType
      role
      mailId
      organizationId
      user {
        username
      }
    }
  }
`;

export const AllContactDetailsQuery = gql`
  
query {
    allContact {
      id
      conid
      firstName
      lastName
      organizationId
      organizationName
      organizationType
      mailId
      createdAt	
      user {
        username
      }
    }
  }
 
`;
export const allContact = gql`
  query {
    allContact {
      id
      firstName
      lastName
      organizationId
      organizationName
      organizationType
      role
      contactNumber
      mailId
      user {
        username
      }
    }
  }
`;
export const getContactdetail = gql`
  query getContactdetail($id: String!) {
    getContactdetail(id: $id) {
      id
      firstName
      lastName
      landLineNumber
      organizationId
      organizationType
      organizationName
      contactNumber
      secondaryNumber
      whatsappNumber
      role
      dateOfBirth
      age
      mailId
      address1Line1
      address1Line2
      country1
      state1
      city1
      zipCode1
    }
  }
`;
export const getQuotationByContactOrganizationId = gql`
  query getContactByUser($organization_id: String!) {
    getQuotationByContactOrganizationId(organizationId: $organization_id) {
      id
      firstName
      lastName
      mailId
      contactNumber
      organizationType
      organizationId
    }
  }
`;

export const AllContactDetailsByUserQuery = gql`
query getContactdetailByUser($id: String!) {
    getContactdetailByUser(id: $id) {
      id
      conid
      firstName
      lastName
      organizationName
      organizationType
      organizationId
      role
      mailId
      user {
        username
      }
    createdAt
    }
  }
`;
export const AllContactDetailsByMasterQuery = gql`
 query getContactdetailByMaster($id: String!) {
    getContactdetailByMaster(id: $id) {
      id
      conid
      firstName
      lastName
      organizationName
      organizationType
      organizationId
      contactNumber
      role
      mailId
      user {
        username
      }
    createdAt
    }
  }
`;
export const getContactdetailByMaster = gql`
  query getContactdetailByMaster($id: String!) {
    getContactdetailByMaster(id: $id) {
      id
      firstName
      lastName
      organizationName
      organizationType
      organizationId
      contactNumber
      role
      mailId
      user {
        username
      }
    }
  }
`;

export const getCustomerByUser = gql`
  query getCustomerByUser($id: String!) {
    getCustomerdetailByUser(id: $id) {
      id
      legalName
      user {
        username
      }
    }
  }
`;
export const getCustomerByMaster = gql`
  query getCustomerByMaster($id: String!) {
    getCustomerdetailByMaster(id: $id) {
      id
      legalName
      user {
        username
      }
    }
  }
`;
export const getVendorByUser = gql`
  query getVendorByUser($id: String!) {
    getVendordetailByUser(id: $id) {
      user {
        id
        username
      }
      id
      legalName
    }
  }
`;
export const getVendorByMaster = gql`
  query getVendorByMaster($id: String!) {
    getVendordetailByMaster(id: $id) {
      user {
        id
        username
      }
      id
      legalName
    }
  }
`;
export const getLeadProspectByUser = gql`
  query getLeadProspectByUser($id: String!) {
    getLeadprospectDetailByUser(id: $id) {
      user {
        id
        username
        masterId
      }
      id
      companyName
    }
  }
`;
export const getLeadProspectByMaster = gql`
  query getLeadProspectByMaster($id: String!) {
    getLeadprospectDetailByMaster(id: $id) {
      user {
        id
        username
        masterId
      }
      id
      companyName
    }
  }
`;
export const AllUOMDetailsQuery = gql`
  query {
    allUom {
      id
      uomid
      user {
        id
        username
      }
      uomName
      uomAbbreviation
      decimalPlaces
      baseUnit
      baseUnitValue
      status
      createdAt
    }
  }
`;

export const AllBrandDetailsQuery = gql`
  query {
    allBrandDetail {
      id
      brandid
      user {
        username
      }
      brandLogo
      brandName
      brandIndustry
      createdAt
    }
  }
`;

export const AllProductCategoryQuery = gql`
  query {
    allProductcategory {
      id
      catid
      categoryName
      user {
        username
      }
      createdAt
    }
  }
`;
export const AllProductCategoryByMasterQuery = gql`
  query getProductcategoryByMaster($id: String!) {
    getProductcategoryByMaster(id: $id) {
      id
      catid
      user {
        id
        email
        username
      }
      categoryName
      status
      lastUpdate
    }
  }
`;
export const AllProductDetailsQuery = gql`
query {
    allProduct {
      id
      productid
      productName
      category {
        id
        categoryName
      }
      brand{
        brandName
      }
      HSNNumber
      productCost
      user {
        username
      }
      createdAt
    }
  }
`;
 
export const getpricing = gql`

query getpricing($id:ID!){
  getPricingById(id:$id){
    id
    designation
    ctc
    monthlyCtc
    dailyCtc
    hourlyCtc
  }
}



`

export const designationfordropdown = gql`
query{
  allPricing{
    id
    designation
    hourlyCtc
  }
}


`

export const gettotalhours = gql`

  query totalhours($optimistic:String!,$pessimistic:String!,$noraml:String!){
  totalHoursCalculation(optimisticTime:$optimistic,pessimisticTime:$pessimistic,normalTime:$noraml){
    totalHours
  }
}


`
export const gettotalAmount = gql`

   query totalamount($totalhours:Float!,$hourlyctc:Float!,$resource:Int!){
  totalAmountCalculation(totalHours:$totalhours,hourlyCtc:$hourlyctc,,resourceCount:$resource){
    totalAmount
  }
}

`

export const gethourlyctc = gql `
 
query getdesigination($id:ID!){
  getPricingById(id:$id){
    hourlyCtc
  }
}


`

export const gettotalcost =gql`
 query alltotalamount($totalamount:[Float!]){
  allTotalAmountCalculation(totalAmount:$totalamount){
    totalAmount
  }
}

`

export const getprojectestimation = gql`

query getprojectestimate($id:ID!){
  getProjectEstimateById(id:$id){
    id
    projectName
    projectestimatedetailsSet{
      id
      designation{
        id
        designation
      }
      resourceCount
      optimisticTime
      pessimisticTime
      normalTime
      totalHours
      totalAmount
    }
    totalCost
    deploymentCost
    deploymentCostPercentage
    contingencyCost
    contingencyCostPercentage
    overheadCost
    overheadCostPercentage
    profitCost
    profitCostPercentage
    projectCost
  }
}

`
export const allprojectestimation = gql`

query{
  allProjectEstimate{
    id
    projectName
    deploymentCost
    contingencyCost
    overheadCost
    profitCost
    projectCost
    user{
      username
    }
    createdAt
  }
}


`
export const AllpricingQuery = gql`
 

query{
  allPricing{
    id
    designation
    ctc
    monthlyCtc
    dailyCtc
    hourlyCtc
     user{ 
      username 
    } 
    createdAt 
  }
}




`
export const getBrandDetail = gql`
  query ($id: String!) {
    getBrandDetail(id: $id) {
      id

      brandName

      brandIndustry

      brandLogo
    }
  }
`;
export const updatebrand = gql`
  mutation updatebrand($input: UpdateBrandDetailInput!) {
    updateBrandDetail(input: $input) {
      branddetails {
        id

        brandName

        brandIndustry

        brandLogo
      }
    }
  }
`;

export const AllWareHouseDetailsQuery = gql`
  query {
    allWarehouse {
      id
      user {
        username
        email
      }
      warehouseName
      category
      addressLine1
      addressLine2
      country
      State
      city
      zipCode
      supervisorName
      supervisorNumber
      warehouseContactNumber
      warehouseCapacity
      capacityUom
      brand {
        id
        brandName
      }
      warehouseCost
      sellingPrice
      SKU
      HSNNumber
      UOM {
        id
        uomName
      }
      reorderLevel
      Tax
      warehouseImage
      Description
      lastUpdate
    }
  }
`;

export const GetbrandDetails = gql`
  query {
    allBrandDetail {
      id
      brandName
      brandIndustry
    }
  }
`;
export const allBrandDetail = gql`
  query {
    allBrandDetail {
      id
      brandName
      brandIndustry
      brandLogo
      user {
        username
      }
    }
  }
`;

export const GetUOMDetails = gql`
  query allUOM {
    allUom {
      id
      uomName
    }
  }
`;

export const GetCategoryDetails = gql`
  query {
    allProductcategory {
      id
      categoryName
    }
  }
`;

export const GetWarehouseDetails = gql`
  query {
    allWarehouse {
      id
      warehouseName
    }
  }
`;

export const GetUserDetailsQuery = gql`
  query getUserDetailByMaster($id: String!) {
    getUserDetailByMaster(id: $id) {
      id
      username
      email
      role
      contactno
      lastUpdate
    }
  }
`;
export const AllSalesStageQuery = gql`
query {
    allSalesstage {
      id
      salid
      stageName
      description
      user {
        username
      }
      createdAt
    }
  }
`;
export const GetSalesStageByUser = gql`
query getSalesstageByUser($id: String!) {
    getSalesstageByUser(id: $id) {
      id
      salid
      stageName
      description
      user {
        username
      }
    createdAt
    }
  }
`;

export const GetSalesStageByMaster = gql`
  query getSalesstageByMaster($id: String!) {
    getSalesstageByMaster(id: $id) {
      id
      salid
      stageName
      description
      user {
        username
      }
    createdAt
    }
}
`;

export const allQuotation = gql`
query {
    allQuotation {
      user {
        id
        masterId
        username
      }
      id
      opportunity {
        id
      }
      qtnid
      relatedName
      quoteStatus
      approvelStatus
      user {
        username
      }
      createdAt
    }
  }
`; // quation showlist superuser query

export const getQuotationDetailByUser = gql`
  query getQuotationByUser($id: String!) {
    getQuotationDetailByUser(id: $id) {
      user {
        id
        masterId
        username
      }
      id
      opportunity {
        id
        oppid
      }
      relatedName
      quoteStatus
      approvelStatus
      user {
        username
      }
    createdAt
    }
  }
`;
export const getQuotationDetailByMaster = gql`
 query getQuotationByMaster($id: String!) {
    getQuotationDetailByMaster(id: $id) {
      user {
        id
        masterId
        username
      }
      id
      qtnid
      opportunity {
        id
      }
      relatedName
      quoteStatus
      approvelStatus
      user {
        username
      }
    createdAt
    }
  }
`;
export const AllOpportunityTypeByMasterQuery = gql`
  query getOpportunitytypeByMaster($id: String!) {
    getOpportunitytypeByMaster(id: $id) {
      id
      optid
      typeName
      description
      user {
        username
      }
    }
  }
`;

export const AllOpportunityTypeByUserQuery = gql`
query getOpportunitytypeByUser($id: String!) {
    getOpportunitytypeByUser(id: $id) {
      id
      optid
      typeName
      description
      user {
        username
      }
    createdAt
    }
  }
`;

export const AllOpportunityTypeQuery = gql`
query {
    allOpportunitytype {
      id
      optid
      typeName
      description
      user {
        username
      }
      createdAt
    }
  }
`;

export const AllOpportunityByMasterQuery = gql`
  query getOpportunityByMaster($id: String!) {
    getOpportunityByMaster(id: $id) {
      id
      oppid
      opportunityType {
        typeName
      }
      user {
        username
      }
      opportunityFrom
      contact {
        firstName
      }
      status
      stage
      createdAt
    }
  }
`;

export const AllOpportunityByUserQuery = gql`
 query getOpportunityByUser($id: String!) {
    getOpportunityByUser(id: $id) {
      id
      oppid
      opportunityType {
        typeName
      }
      user {
        username
      }
      opportunityFrom
      contact {
        firstName
      }
      status
      stage
    createdAt
    }
  }
`;

export const AllOpportunityQuery = gql`
query{
  allOpportunity{
    id
    oppid
    opportunityType{
      typeName
    }
    opportunityFrom
    contact{
      firstName
    }
    stage
    user{
      username
    }
    createdAt
  }
}
`;
export const QuotationOpportunityQuery = gql`
query{
  allOpportunity{
    id
    oppid
  }
}
`;

export const getOpportunityTypeByMasterOptions = gql`
  query getOpportunitytypeByMaster($id: String!) {
    getOpportunitytypeByMaster(id: $id) {
      id
      typeName
      description
    }
  }
`;

export const getOpportunityTypeByUserOptions = gql`
  query getOpportunitytypeByUser($id: String!) {
    getOpportunitytypeByUser(id: $id) {
      id
      typeName
      description
    }
  }
`;

export const getAllOpportunityTypeOptions = gql`
  query {
    allOpportunitytype {
      id
      typeName
      description
    }
  }
`;
export const getSalesStageByMasterOptions = gql`
  query getSalesstageByMaster($id: String!) {
    getSalesstageByMaster(id: $id) {
      id
      stageName
      description
    }
  }
`;

export const getSalesStageByUserOptions = gql`
  query getSalesstageByUser($id: String!) {
    getSalesstageByUser(id: $id) {
      id
      stageName
      description
    }
  }
`;

export const getAllSalesStageOptions = gql`
  query {
    allSalesstage {
      id
      stageName
      description
    }
  }
`;

export const getContactDetailsByMasterOptions = gql`
  query getContactdetailByMaster($id: String!) {
    getContactdetailByMaster(id: $id) {
      id
      firstName
      lastName
      organizationName
      organizationType
      role
      mailId
    }
  }
`;

export const getContactDetailsByUserOptions = gql`
  query getContactdetailByUser($id: String!) {
    getContactdetailByUser(id: $id) {
      id
      firstName
      lastName
      organizationName
      organizationType
      role
      mailId
    }
  }
`;

export const getAllContactDetailsOptions = gql`
  query {
    allContact {
      id
      firstName
      lastName
      organizationName
      organizationType
      role
      mailId
    }
  }
`;

export const getOpportunitytype = gql`
  query getSalesstage($id: String!) {
    getOpportunitytype(id: $id) {
      id
      typeName
      description
    }
  }
`;

export const getProductcategory = gql`
  query getCategory($id: String!) {
    getProductcategory(id: $id) {
      id
      categoryName
    }
  }
`;
export const getSalesstage = gql`
  query getSalesstage($id: String!) {
    getSalesstage(id: $id) {
      id
      stageName
      description
    }
  }
`;
export const getCustomerDetail = gql`
  query getCustomerDetail($id: String!) {
    getCustomerDetail(id: $id) {
      id
      GSTNumber
      legalName
      tradeName
      customerCategory
      pan
      dateOfRegistration
      taxpayerType
      mailId
      address1Line1
      address1Line2
      country1
      state1
      city1
      zipCode1
      address2Line1
      address2Line2
      state2
      city2
      country2
      zipCode2
    }
  }
`;

export const getVendorDetail = gql`
  query getVendorDetail($id: String!) {
    getVendorDetail(id: $id) {
      id
      GSTNumber
      legalName
      vendorCategory
      tradeName
      taxpayerType

      mailId
      pan
      dateOfRegistration
      address1Line1
      address1Line2
      address2Line1
      address2Line2
      state1
      state2
      city1
      city2
      zipCode1
      zipCode2
      country1
      country2
    }
  }
`;

export const getUom = gql`
  query getUom($id: String!) {
    getUom(id: $id) {
      id
      uomName
      uomAbbreviation
      roundOff
      decimalPlaces
      baseUnitValue
      baseUnit
      status
    }
  }
`;

export const allCustomer = gql`
  query {
    allCustomer {
      id
      legalName
      user {
        username
      }
    }
  }
`;

export const allVendor = gql`
  query {
    allVendor {
      user {
        id
        username
      }
      id
      legalName
    }
  }
`;
// export const allLeadprospect = gql`
//   query {
//     allLeadprospect {
//       user {
//         id

//         username

//         masterId
//       }
//       id
//       companyName
//       firstName
//     }
//   }
// `;

export const allAppointment = gql`
query {
    allAppointment {
      id
      appid
      scheduledDate
      time
      appoinmentWith
      withName
      contactPerson
      name
      email
      appointmentStage
      phoneNumber
      status
      description
      user {
        username
      }
      createdAt
    }
  }
`;

export const getAppointmentDetailByUser = gql`
  query getAppointmentByUser($id: String!) {
    getAppointmentDetailByUser(id: $id) {
      id
<<<<<<< HEAD
      appid
=======
      
>>>>>>> origin/prashanth
      scheduledDate
      time
      name
      phoneNumber
      status
      description
      user {
        username
      }
    createdAt
    }
  }
`;
export const getAppointmentDetailByMaster = gql`
 query getAppointmentByMaster($id: String!) {
    getAppointmentDetailByMaster(id: $id) {
      id
<<<<<<< HEAD
      appid
=======
      
>>>>>>> origin/prashanth
      scheduledDate
      time
      name
      phoneNumber
      status
      description
      user {
        username
      }
    createdAt
    }
  }
`;

export const ConvertToQuotation = gql`
  query converttoquotation($id:String!){
  getOpportunity(id:$id){
    id
    oppid
    opportunityFrom
    relatedName
    contact{
      id
      firstName
    }
  }
}
`
export const getOpportunity = gql`
  query getOpportunity($id: String!) {
    getOpportunity(id: $id) {
      id
      opportunityType {
        id
        typeName
      }
      opportunityFrom
      opportunityOwner
      contact {
        id
        firstName
      }
      Source
      status
      stage
      customerOrLeadName
      relatedName
      winProbability
      expectedClosingDate
      opportunityAmount
    }
  }
`;

export const getCustomerdetailByUser = gql`
  query getCustomerByUser($id: String!) {
    getCustomerdetailByUser(id: $id) {
      id
      GSTNumber
      legalName
      tradeName
      customerCategory
      pan
      dateOfRegistration
      mailId
      address1Line1
      address1Line2
      country1
      state1
      city1
      zipCode1
      address2Line1
      address2Line2
      state2
      city2
      country2
      zipCode2
    }
  }
`;

export const updaterole = gql`
  mutation updaterole($id: String!, $role: String!) {
    updateRoleDetail(id: $id, role: $role) {
      set
    }
  }
`;

export const getAppointmentDetail = gql`
  query getAppointmentDetail($id: String!) {
    getAppointmentDetail(id: $id) {
      id
      masterId
      scheduledDate
      time
      appoinmentWith
      withName
      contactPerson
      name
      email
      phoneNumber
      description
      appointmentStage
      status
      reason
      opportunity{
      id
      oppid
      }
      applicationdemoSet {
        id
        appointedPerson {
          id
          username
        }
      }
    }
  }
`;

export const getUserDetail = gql`
  query getUserDetail($id: String!) {
    getUserDetail(id: $id) {
      id
      username
      email
      role
      contactno
      lastUpdate
      user {
        username
      }
    }
  }
`;

export const getAppHistory = gql`
query getapphistorybyid($id:String!){
  getAppointmenthistoryDetailbyid(id:$id){
      id
      scheduledDate
      time
      appoinmentWith
      withName
      contactPerson
      name
      email
      phoneNumber
      description
      status
      reason
    opportunity{
      id
      oppid
    }
    applicationdemohistorySet{
      id
      appointedPerson{
        id
        username
      }
    }
  }
}
`


export const getProductDetail = gql`
  query getProductDetail($id: String!) {
    getProductdetail(id: $id) {
      id

      productName

      category {
        id

        categoryName
      }

      brand {
        id

        brandName
      }

      productCost

      sellingPrice

      SKU

      HSNNumber

      UOM {
        id

        uomName
      }

      reorderLevel

      location {
        id

        warehouseName
      }

      Tax

      productImage

      description
    }
  }
`;

export const getWarehousedetail = gql`
  query getWarehouseDetail($id: String!) {
    getWarehousedetail(id: $id) {
      id
      user {
        id
        username
      }
      masterId
      warehouseName
      category
      addressLine1
      addressLine2
      country
      State
      city
      zipCode
      supervisorName
      supervisorNumber
      warehouseContactNumber
      warehouseCapacity
      capacityUom
      brand {
        id
        brandName
      }
      warehouseCost
      sellingPrice
      SKU
      HSNNumber
      UOM {
        id
        uomName
      }
      reorderLevel
      Tax
      warehouseImage
      Description
      lastUpdate
    }
  }
`;
